// Mirrors backend Config/grievanceStatus.js — pms_grievance.status is a
// TINYINT, this maps the codes to display labels for filters/lists.
export const GRIEVANCE_STATUS_OPTIONS = [
  { label: "Submitted", value: "1" },
  { label: "Under Review", value: "2" },
  { label: "Assigned", value: "3" },
  { label: "Investigation", value: "4" },
  { label: "Action Required", value: "5" },
  { label: "Resolved", value: "6" },
  { label: "Closed", value: "8" },
  { label: "Rejected", value: "9" },
  { label: "Reopened", value: "10" },
  { label: "Withdrawn", value: "12" },
];

// Mirrors backend Config/grievanceWorkflow.js GRIEVANCE_SLA_DAYS: calendar
// days HR has to resolve a case, by priority. Change both together.
export const GRIEVANCE_SLA_DAYS = { Low: 7, Medium: 5, High: 3 };

// "Low (7 days)" — the priority with its response target.
export const priorityWithDays = (priority) =>
  GRIEVANCE_SLA_DAYS[priority] ? `${priority} (${GRIEVANCE_SLA_DAYS[priority]} days)` : priority;
